export const circleDomainItem = {
    binary: "uint",
    size: 4,
};
export const circleNonceItem = {
    binary: "uint",
    size: 8,
};
//# sourceMappingURL=circle.js.map